// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Page_hidden__eDrGO","wrapper":"Page_wrapper__2c6jV","background":"Page_background__1afya"};